import { CoverFile } from '../types';

/**
 * Converts a File object to a CoverFile format (base64 encoded with extension)
 * @param file - The File object to convert
 * @returns Promise that resolves to a CoverFile object
 */
export const convertFileToBase64 = (file: File): Promise<CoverFile> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const base64String = reader.result as string;
      const base64Data = base64String.split(',')[1];
      const extension = file.name.split('.').pop()?.toLowerCase() || 'jpg';
      resolve({ file: base64Data, extension });
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
};

